import { GQL } from '../graphQl'

export const lifeCycleStatusUpdateMutation = () => GQL`mutation lifeCycleStatusUpdateMutation($bom_id: uuid, $document_id: uuid, $material_id: uuid, $status: Int!, $undo_checkout: Boolean = false) {
  update_lifecycle_status(
    status: $status
    bom_id: $bom_id
    document_id: $document_id
    material_id: $material_id
    undo_checkout: $undo_checkout
  ) {
    message
  }
}`

export const StartLifecycleWorkflowMutation = () => GQL`mutation StartLifecycleWorkflowMutation($materialId: uuid, $bomId: uuid, $documentId: uuid, $stepId: uuid!, $templateId: uuid!, $assignees: [lifecycle_step_assignees!]) {
  start_lifecycle_workflow(material_id: $materialId, bom_id: $bomId, document_id: $documentId, step_id: $stepId, template_id: $templateId, assignees: $assignees) {
    message
    workflow_instance_id
  }
}`
